<template>
    <v-dialog v-model="dialog" max-width="450">
        <v-card class="v-card--dialog rounded-xl">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">도서 구입비 소득공제 안내</h3>
                <v-btn fab color="transparent" class="v-card--dialog__close" @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <v-divider class="grey lighten-1 mt-10px"/>
            <v-card-text>
                - 2018.7.1부터 도서 구입비에 대해 공제율 30% 연 100만원까지 추가 소득공제가 가능합니다.
            </v-card-text>
            <v-card-text>
                - 소득 공제 대상자는 총급여 7천만 원 이하 근로소득자 중 신용/직불카드 사용액이 총 급여의 25% 이상인 자입니다.
            </v-card-text>
            <v-card-text>
                - 소득 공제 대상 상품군은 베스트셀러/유아동/할인도서/독립출판물(ISBN 포함) 입니다.
            </v-card-text>
            <v-card-text>
                - ISBN이 발행되지 않은 독립출판물에 대해서는 발급되지 않습니다.
            </v-card-text>
            <v-card-text>
                - 해당 상품을 신용카드로 결제하실 경우 도서 소득공제가 적용됩니다.
            </v-card-text>
            <v-card-text>
                - 소득 공제 대상 도서 구매 금액은 배송비가 포함된 금액입니다.
            </v-card-text>
            <v-card-text>
                - 문화비소득공제 신청내역은 별도의 영수증 출력이 불가하며 연말정산 시 간소화 서비스에서 조회가 가능합니다.
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false
        }
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
        }
    }
}
</script>

<style scoped>
</style>